/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    h3: "h3",
    h4: "h4",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    ul: "ul",
    li: "li",
    em: "em"
  }, _provideComponents(), props.components), {Warning, Specialization, Boon, Skill, Trait, Effect, Divider, CharacterWithAr, Character, Attribute, Item, Grid, GridItem, Traits, Condition, Card, Skills, Weapons} = _components;
  if (!Attribute) _missingMdxReference("Attribute", true);
  if (!Boon) _missingMdxReference("Boon", true);
  if (!Card) _missingMdxReference("Card", true);
  if (!Character) _missingMdxReference("Character", true);
  if (!CharacterWithAr) _missingMdxReference("CharacterWithAr", true);
  if (!Condition) _missingMdxReference("Condition", true);
  if (!Divider) _missingMdxReference("Divider", true);
  if (!Effect) _missingMdxReference("Effect", true);
  if (!Grid) _missingMdxReference("Grid", true);
  if (!GridItem) _missingMdxReference("GridItem", true);
  if (!Item) _missingMdxReference("Item", true);
  if (!Skill) _missingMdxReference("Skill", true);
  if (!Skills) _missingMdxReference("Skills", true);
  if (!Specialization) _missingMdxReference("Specialization", true);
  if (!Trait) _missingMdxReference("Trait", true);
  if (!Traits) _missingMdxReference("Traits", true);
  if (!Warning) _missingMdxReference("Warning", true);
  if (!Weapons) _missingMdxReference("Weapons", true);
  return React.createElement(React.Fragment, null, React.createElement(Warning, null, React.createElement(_components.p, null, "This build is very common in PuGs. It is currently the best heal build to use in PuGs. More info about this can be found ", React.createElement(_components.a, {
    href: "/guides/teamcomp101/"
  }, "here"), ". This build provides a high amount of boons and a lot of safety to the group via its healing. It, therefore, shines most in less experienced groups as well as when you have bad instabilities.")), "\n", React.createElement(_components.p, null, "The ", React.createElement(Specialization, {
    name: "Mechanist",
    text: "Heal Alacrity Mechanist"
  }), " provides permanent ", React.createElement(Boon, {
    name: "Might"
  }), ", ", React.createElement(Boon, {
    name: "Alacrity"
  }), ", ", React.createElement(Boon, {
    name: "Fury"
  }), ", ", React.createElement(Boon, {
    name: "Regeneration"
  }), " and ", React.createElement(Boon, {
    name: "Vigor"
  }), ", as well as some ", React.createElement(Boon, {
    name: "Protection"
  }), ". It also has access to a small amount of ", React.createElement(Boon, {
    name: "Aegis"
  }), ", ", React.createElement(Boon, {
    name: "Stability"
  }), " through ", React.createElement(Skill, {
    id: "63293",
    id: "63293"
  }), "."), "\n", React.createElement(_components.p, null, "It offers a large of healing thanks to ", React.createElement(Skill, {
    name: "Med Kit",
    id: "5802"
  }), ", ", React.createElement(Skill, {
    name: "Super Elixir",
    id: "5937"
  }), ", permanent ", React.createElement(Boon, {
    name: "Regeneration"
  }), " and ", React.createElement(Boon, {
    name: "Vigor"
  }), " that you get from ", React.createElement(Skill, {
    name: "Energizing Slam",
    id: "63169"
  }), ". Whenever you use a Jade Golem skill it pumps out more healing when traited with ", React.createElement(Trait, {
    name: "Soothing Detonation",
    id: "1834"
  }), ". You can also provide a huge amount of ", React.createElement(Effect, {
    name: "barrier"
  }), " with ", React.createElement(Skill, {
    id: "63141",
    id: "63141"
  }), " and ", React.createElement(Skill, {
    name: "Barrier Signet",
    id: "63262"
  }), " maintaing a near permanant uptime on your party."), "\n", React.createElement(Divider, {
    text: "Equipment"
  }), "\n", React.createElement(CharacterWithAr, null, React.createElement(Character, {
    title: "",
    gear: "{\"attributes\":{\"profession\":\"Engineer\",\"specialization\":\"Mechanist\",\"data\":{\"Health\":20522,\"Armor\":2750,\"Power\":2724,\"Precision\":1000,\"Toughness\":1632,\"Vitality\":1533,\"Ferocity\":0,\"Condition Damage\":750,\"Expertise\":0,\"Concentration\":1501,\"Healing Power\":1696,\"Agony Resistance\":150,\"Condition Duration\":0,\"Boon Duration\":1.1506666666666665,\"Critical Chance\":0.3,\"Critical Damage\":1.5,\"Power Coefficient\":0,\"Power2 Coefficient\":0,\"Burning Coefficient\":0,\"Bleeding Coefficient\":0,\"Poison Coefficient\":0,\"Torment Coefficient\":0,\"Confusion Coefficient\":0,\"Flat DPS\":0,\"Outgoing Healing\":0.46964000000000006,\"Effective Power\":4503.1125,\"NonCrit Effective Power\":3915.75,\"Power DPS\":0,\"Power2 DPS\":0,\"Siphon DPS\":0,\"Bleeding Damage Tick\":96.3125,\"Bleeding Stacks\":0,\"Bleeding DPS\":0,\"Burning Damage Tick\":355.421875,\"Burning Stacks\":0,\"Burning DPS\":0,\"Confusion Damage Tick\":103.55175,\"Confusion Stacks\":0,\"Confusion DPS\":0,\"Poison Damage Tick\":112.84375,\"Poison Stacks\":0,\"Poison DPS\":0,\"Torment Damage Tick\":142.74375,\"Torment Stacks\":0,\"Torment DPS\":0,\"Damage\":0,\"Effective Health\":133606296.37915584,\"Survivability\":67923.89241441578,\"Effective Healing\":1320.912432,\"Healing\":1320.912432}},\"armor\":{\"weight\":\"Medium\",\"helmAffix\":\"Harrier\",\"helmRuneId\":24842,\"helmRune\":\"Monk\",\"helmRuneCount\":6,\"helmInfusionId\":37125,\"shouldersAffix\":\"Giver\",\"shouldersRuneId\":24842,\"shouldersRune\":\"Monk\",\"shouldersRuneCount\":6,\"shouldersInfusionId\":37125,\"coatAffix\":\"Harrier\",\"coatRuneId\":24842,\"coatRune\":\"Monk\",\"coatRuneCount\":6,\"coatInfusionId\":37125,\"glovesAffix\":\"Harrier\",\"glovesRuneId\":24842,\"glovesRune\":\"Monk\",\"glovesRuneCount\":6,\"glovesInfusionId\":37125,\"leggingsAffix\":\"Harrier\",\"leggingsRuneId\":24842,\"leggingsRune\":\"Monk\",\"leggingsRuneCount\":6,\"leggingsInfusionId\":37125,\"bootsAffix\":\"Harrier\",\"bootsRuneId\":24842,\"bootsRune\":\"Monk\",\"bootsRuneCount\":6,\"bootsInfusionId\":37125},\"weapon\":{\"weapon1MainId\":30692,\"weapon1MainType\":\"Mace\",\"weapon1MainSigil1Id\":74326,\"weapon1MainAffix\":\"Giver\",\"weapon1MainInfusion1Id\":37125,\"weapon1OffId\":30696,\"weapon1OffType\":\"Shield\",\"weapon1OffAffix\":\"Giver\",\"weapon1OffInfusionId\":86180,\"weapon1OffSigilId\":24639,\"weapon2MainInfusion2Id\":86180},\"backAndTrinket\":{\"backItemAffix\":\"Harrier\",\"backItemInfusion1Id\":37125,\"backItemInfusion2Id\":37125,\"amuletAffix\":\"Harrier\",\"ring1Affix\":\"Harrier\",\"ring1Infusion1Id\":37125,\"ring1Infusion2Id\":37125,\"ring1Infusion3Id\":37125,\"ring2Affix\":\"Harrier\",\"ring2Infusion1Id\":37125,\"ring2Infusion2Id\":37125,\"ring2Infusion3Id\":37125,\"accessory1Affix\":\"Giver\",\"accessory1InfusionId\":37125,\"accessory2Affix\":\"Harrier\",\"accessory2InfusionId\":37125},\"consumables\":{\"foodId\":91690,\"utilityId\":67528,\"relicId\":101268},\"skills\":{\"healId\":5802,\"utility1Id\":\"\",\"utility2Id\":5933,\"utility3Id\":63262,\"eliteId\":30800},\"assumedBuffs\":{\"value\":[{\"id\":\"might\",\"type\":\"Boon\"},{\"id\":\"fury\",\"type\":\"Boon\"},{\"id\":\"protection\",\"type\":\"Boon\"},{\"id\":\"vulnerability\",\"type\":\"Condition\"},{\"id\":\"reinforced-armor\",\"type\":\"Text\"},{\"id\":\"jade-bot\",\"gw2id\":96613,\"type\":\"Item\"},{\"id\":\"omnipotion\",\"gw2id\":79722,\"type\":\"Item\"}]},\"traits\":{\"selection\":[[394,1834,1916],[521,470,473],[2296,2276,2281]],\"lines\":[47,29,70]}}"
  }, React.createElement(_components.p, null, "Due to your Mech not inheriting any ", React.createElement(Attribute, {
    name: "Boon Duration"
  }), " modifiers or converted stats, such as the ", React.createElement(Attribute, {
    name: "Agony Resistance"
  }), " to ", React.createElement(Attribute, {
    name: "Concentration"
  }), " conversion from the ", React.createElement(Item, {
    id: "75427",
    id: "75427"
  }), " with the Fractal Attunement masteries, it makes sense to use the raid setup found on ", React.createElement(_components.a, {
    href: "https://snowcrows.com/builds/engineer/mechanist/heal-alacrity-mechanist"
  }, "Snow Crows"), ". You can check the ", React.createElement(_components.a, {
    href: "https://optimizer.discretize.eu/"
  }, "gear optimizer"), " for more gear variants, but be mindful you have enough ", React.createElement(Attribute, {
    name: "Concentration"
  }), " to maintain boons!"))), "\n", React.createElement(Divider, {
    text: "Traits and Skills"
  }), "\n", React.createElement(_components.h3, null, "Traits"), "\n", React.createElement(Grid, null, React.createElement(GridItem, {
    sm: "6"
  }, React.createElement(Traits, {
    traits1: "Inventions",
    traits1Selected: "Over Shield, Soothing Detonation, Medical DIspersion Field",
    traits2: "Alchemy",
    traits2Selected: "Health Insurance, Backpack Regenerator, HGH",
    traits3: "Mechanist",
    traits3Selected: "Mech Arms: High-Impact Drivers, Mech Frame: Channeling Conduits, Mech Core: Barrier Engine",
    traits1Id: "47",
    traits1SelectedIds: "394,1834,1916",
    traits2Id: "29",
    traits2SelectedIds: "521,470,473",
    traits3Id: "70",
    traits3SelectedIds: "2296,2276,2281"
  }), React.createElement(_components.h4, null, "Situational Traits"), React.createElement(_components.table, null, React.createElement(_components.thead, null, React.createElement(_components.tr, null, React.createElement(_components.th), React.createElement(_components.th))), React.createElement(_components.tbody, null, React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Trait, {
    name: "Experimental Turrets",
    size: "big",
    disableText: true,
    id: "1678"
  })), React.createElement(_components.td, null, "Taken if you are running turret skills. Grant boons depending on the deployed skills.")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Trait, {
    name: "Purity of Purpose",
    size: "big",
    disableText: true,
    id: "1871"
  })), React.createElement(_components.td, null, "Useful on condi heavy and boonstrip heavy encounters to mass condi cleans and generate boons.")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Trait, {
    name: "Gyroscopic Acceleration",
    size: "big",
    disableText: true,
    id: "1917"
  })), React.createElement(_components.td, null, "In the ", React.createElement(Specialization, {
    name: "Scrapper"
  }), " traitline. Useful to share ", React.createElement(Effect, {
    name: "superspeed"
  }), " for movement and skips.")))), React.createElement(_components.h3, null, "Defiance Bars"), React.createElement(_components.table, null, React.createElement(_components.thead, null, React.createElement(_components.tr, null, React.createElement(_components.th, null, "Skill"), React.createElement(_components.th, null, "Defiance Bar Damage"))), React.createElement(_components.tbody, null, React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Rocket Fist Prototype",
    id: "63234"
  })), React.createElement(_components.td, null, "100 damage")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Magnetic Inversion  ",
    id: "6126"
  })), React.createElement(_components.td, null, "150 damage")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Throw Shield",
    id: "6057"
  })), React.createElement(_components.td, null, "100 damage")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Thump",
    id: "5889"
  })), React.createElement(_components.td, null, "232 damage (hits twice if not destroyed)")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Personal Battering Ram",
    id: "5811"
  })), React.createElement(_components.td, null, "232 damage")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Endothermic Shell",
    id: "30307"
  })), React.createElement(_components.td, null, React.createElement(Condition, {
    name: "Chilled"
  }), " 33/s damage")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Glob Shot",
    id: "5935"
  })), React.createElement(_components.td, null, React.createElement(Condition, {
    name: "Crippled"
  }), " 20/s damage")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    id: "63365",
    id: "63365"
  })), React.createElement(_components.td, null, React.createElement(Condition, {
    name: "Weakness"
  }), " 20/s damage"))))), React.createElement(GridItem, {
    sm: "6"
  }, React.createElement(_components.h3, null, "Situational Utility Skills"), React.createElement(_components.table, null, React.createElement(_components.thead, null, React.createElement(_components.tr, null, React.createElement(_components.th), React.createElement(_components.th))), React.createElement(_components.tbody, null, React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Personal Battering Ram",
    size: "big",
    disableText: true,
    id: "5811"
  })), React.createElement(_components.td, null, "Used to provide CC if no other utility is needed")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Shift Signet",
    size: "big",
    disableText: true,
    id: "63111"
  })), React.createElement(_components.td, null, "Can be used as a stunbreak and also allows greater control of your mech porting it and yourself to your target. Additionally can be used as a dps increase,")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Thumper Turret",
    size: "big",
    disableText: true,
    id: "5838"
  })), React.createElement(_components.td, null, "Deals a large amount of CC. If using ", React.createElement(Trait, {
    name: "Experimental Turrets",
    id: "1678"
  }), " will also share ", React.createElement(Boon, {
    name: "Protection"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Net Turret",
    size: "big",
    disableText: true,
    id: "5837"
  })), React.createElement(_components.td, null, "If using ", React.createElement(Trait, {
    name: "Experimental Turrets",
    id: "1678"
  }), " can be placed to share ", React.createElement(Boon, {
    name: "Swiftness"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Tool Kit",
    size: "big",
    disableText: true,
    id: "5904"
  })), React.createElement(_components.td, null, "Has access to a block with ", React.createElement(Skill, {
    id: "5998",
    id: "5998"
  }), " and a pull with ", React.createElement(Skill, {
    id: "5996",
    id: "5996"
  }))), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Throw Mine",
    size: "big",
    disableText: true,
    id: "6161"
  })), React.createElement(_components.td, null, "Can be used for some emergency boonstrip")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Overclock Signet",
    size: "big",
    disableText: true,
    id: "63095"
  })), React.createElement(_components.td, null, "Can be used to resummon your mech if ", React.createElement(Skill, {
    name: "Crash Down",
    id: "63050"
  }), " is on cooldown")), React.createElement(_components.tr, null, React.createElement(_components.td, null, React.createElement(Skill, {
    name: "Sneak Gyro",
    size: "big",
    disableText: true,
    id: "30815"
  })), React.createElement(_components.td, null, "A ", React.createElement(Specialization, {
    name: "Scrapper"
  }), " skill, used for group ", React.createElement(Effect, {
    name: "Stealth"
  }), " in T4 fractals.")))))), "\n", React.createElement(Divider, {
    text: "Skill Explanations"
  }), "\n", React.createElement(_components.h3, null, "Weapons"), "\n", React.createElement(Grid, null, React.createElement(GridItem, {
    sm: "6"
  }, React.createElement(_components.h4, null, "Mace"), React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Energizing Slam",
    id: "63169"
  }), " grants ", React.createElement(Boon, {
    name: "Regeneration"
  }), " and ", React.createElement(Boon, {
    name: "Vigor"
  }), " to allies, while applying some ", React.createElement(Condition, {
    name: "Vulnerability"
  }), " to enemies."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Rocket Fist Prototype",
    id: "63234"
  }), " can be used for CC."), "\n")), React.createElement(GridItem, {
    sm: "6"
  }, React.createElement(_components.h4, null, "Shield"), React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Magnetic Shield",
    id: "6053"
  }), " offers projectile reflection and some CC when released though ", React.createElement(Skill, {
    name: "Magnetic Inversion  ",
    id: "6126"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Static Shield",
    id: "6054"
  }), " can be used as a long block that CCs any enemies attacking you. After the block is over it will cc with ", React.createElement(Skill, {
    name: "Throw Shield",
    id: "6057"
  }), "."), "\n"))), "\n", React.createElement(_components.h3, null, "Kits"), "\n", React.createElement(_components.p, null, "A large part of the support is generated through the use of your Jade Mech and Kits."), "\n", React.createElement(_components.p, null, "Engineering kits can be opened instantly to give access to 5 new skills, which when closed again return you to your weapon set. Each kit skill will have its separate cooldown, although as you play the class you come to get a feel for when each skill will be available."), "\n", React.createElement(_components.p, null, React.createElement(Skill, {
    name: "Crash Down",
    text: "Jade Mech",
    size: "medium",
    id: "63050"
  }), ":"), "\n", React.createElement(_components.p, null, "Your jade mech is your main source of ", React.createElement(Boon, {
    name: "Alacrity"
  }), " generation, while also providing a significant portion of your other boons. It inherits your concentration and healing power thanks to ", React.createElement(Trait, {
    name: "Mech Frame: Channeling Conduits",
    id: "2276"
  }), "."), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    id: "63365",
    id: "63365"
  }), " and your Mechs auto attacks will slowly generate a small amount of might thanks to ", React.createElement(Trait, {
    name: "Mech Arms: High-Impact Drivers",
    id: "2296"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    id: "63293",
    id: "63293"
  }), " grants ", React.createElement(Boon, {
    name: "Alacrity"
  }), ", ", React.createElement(Boon, {
    name: "Protection"
  }), ", ", React.createElement(Boon, {
    name: "Stability"
  }), " and ", React.createElement(Boon, {
    name: "Aegis"
  }), " to 5 targets. It also is a condition cleanse and a stun break."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    id: "63141",
    id: "63141"
  }), " pulses ", React.createElement(Boon, {
    name: "Might"
  }), " abd ", React.createElement(Boon, {
    name: "Fury"
  }), " to 5 targets resulting in 30 seconds of ", React.createElement(Boon, {
    name: "Might",
    text: "15 Might"
  }), " and ", React.createElement(Boon, {
    name: "Fury"
  }), " being shared. It also generates a large amount of ", React.createElement(Effect, {
    name: "Barrier"
  }), " which in turn generates ", React.createElement(Boon, {
    name: "Alacrity"
  }), " thanks to ", React.createElement(Trait, {
    name: "Mech Frame: Channeling Conduits",
    id: "2276"
  }), "."), "\n", React.createElement(_components.li, null, "You can summon your Mech using ", React.createElement(Skill, {
    name: "Crash Down",
    id: "63050"
  }), " and recall it with ", React.createElement(Skill, {
    name: "Recall Mech",
    id: "63089"
  })), "\n", React.createElement(_components.li, null, "Sometimes your Mech can get stuck, you can try to use ", React.createElement(_components.em, null, "Return to Me"), " to get it to come to you, if this doesn't work you may have to recall it instead. Alternatively if ", React.createElement(Skill, {
    name: "Shift Signet",
    id: "63111"
  }), " is availible, this can be used to port your Mech to your target."), "\n", React.createElement(_components.li, null, "Remember your Mech commands will generate boons in a radius around your Mech. Make sure it is in range of you and your party before using them!"), "\n"), "\n", React.createElement(_components.p, null, React.createElement(Skill, {
    name: "Med Kit",
    size: "medium",
    id: "5802"
  }), ":"), "\n", React.createElement(_components.p, null, "Your Med Kit is your main source of healing. It has a mixture of condi cleanse, supportive boon generation, and burst healing thanks to ", React.createElement(Trait, {
    name: "Health Insurance",
    id: "521"
  })), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Med Blaster",
    id: "30521"
  }), " and ", React.createElement(Skill, {
    name: "Bandage Blast",
    id: "29547"
  }), " provide a large amount of constant healing to your party."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Cleansing Field",
    id: "49045"
  }), " will cleanse up to 4 conditions over 3 seconds, while also providing a water field that can be used for blast heals."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Vital Burst",
    id: "49082"
  }), " is a large group heal that should be used to recover from high incoming damage."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Infusion Bomb",
    id: "50444"
  }), " is a blast finisher that can be used to blast your water field from ", React.createElement(Skill, {
    name: "Cleansing Field",
    id: "49045"
  }), " for burst healing. It also provides some ", React.createElement(Boon, {
    name: "Regeneration"
  }), ", ", React.createElement(Boon, {
    name: "Vigor"
  }), " and ", React.createElement(Boon, {
    name: "Swiftness"
  }), "."), "\n", React.createElement(_components.li, null, "Remember that many skills in ", React.createElement(Skill, {
    name: "Med Kit",
    id: "5802"
  }), " heal in a small radius so make sure you are close to your party."), "\n"), "\n", React.createElement(_components.p, null, React.createElement(Skill, {
    name: "Elixir Gun",
    size: "medium",
    id: "5933"
  }), ":"), "\n", React.createElement(_components.p, null, "Provides some additional support through condi cleanse, some burst healing, and slow CC."), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Tranquilizer Dart",
    id: "5934"
  }), " applies ", React.createElement(Condition, {
    name: "Weakness"
  }), " for some slow CC."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Glob Shot",
    id: "5935"
  }), " applies ", React.createElement(Condition, {
    name: "Crippled"
  }), " for some slow CC. When hitting an enemy it will also share ", React.createElement(Boon, {
    name: "Swiftness"
  }), " to allies."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Fumigate",
    id: "5965"
  }), " is a mass condi cleanse, cleansing up to 5 conditions from allies. It also applies a small amount of ", React.createElement(Condition, {
    name: "Vulnerability"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Acid Bomb",
    id: "5936"
  }), " is a blast finisher. Also since it is an Elixir it grants ", React.createElement(Boon, {
    name: "might"
  }), " through ", React.createElement(Trait, {
    name: "HGH",
    id: "473"
  })), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Super Elixir",
    id: "5937"
  }), " is a burst heal, Once hit it also creates an area of continual healing for 10 seconds, making this one of your best healing abilities. It also condi-cleanses and grants ", React.createElement(Boon, {
    name: "might"
  }), " through ", React.createElement(Trait, {
    name: "HGH",
    id: "473"
  })), "\n", React.createElement(_components.li, null, "While not every skill in this kit is commonly used, in particular, the condi cleanse and burst heal are very useful in high-pressure situations."), "\n"), "\n", React.createElement(_components.p, null, React.createElement(Skill, {
    name: "Elite Mortar Kit",
    size: "medium",
    id: "30800"
  }), ":"), "\n", React.createElement(_components.p, null, "While not every skill is commonly used, it still provides some slow CC and has access to a strong AoE pulsing heal."), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Endothermic Shell",
    id: "30307"
  }), " applies a large amount of slow CC through ", React.createElement(Condition, {
    name: "Chilled"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Flash Shell",
    id: "30121"
  }), " applies some slow cc through ", React.createElement(Condition, {
    name: "Blinded"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Elixir Shell",
    id: "30032"
  }), " is a strong AoE pulsing heal that can be used proactively before high pressure situations. It also grants ", React.createElement(Boon, {
    name: "might"
  }), " through ", React.createElement(Trait, {
    name: "HGH",
    id: "473"
  }), "."), "\n"), "\n", React.createElement(Divider, {
    text: "Providing Boons"
  }), "\n", React.createElement(Grid, null, React.createElement(GridItem, {
    sm: "6"
  }, React.createElement(_components.h4, null, "Standard Boons"), React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(Boon, {
    name: "Alacrity"
  }), " is applied by two methods. The first is ", React.createElement(Skill, {
    id: "63293",
    id: "63293"
  }), ", which should be pressed off cooldown. In addition to this through the trait ", React.createElement(Trait, {
    name: "Mech Frame: Channeling Conduits",
    id: "2276"
  }), ", when you apply ", React.createElement(Effect, {
    name: "Barrier"
  }), " you will also share ", React.createElement(Boon, {
    name: "Alacrity"
  }), ". With high ", React.createElement(Attribute, {
    name: "Boon Duration"
  }), " it is very easy to upkeep 100% duration."), "\n", React.createElement(_components.li, null, React.createElement(Boon, {
    name: "Might"
  }), " is mainly generated from ", React.createElement(Skill, {
    id: "63141",
    id: "63141"
  }), ", which will allow you to easily maintain 15 stacks. Outside of this you slowly generate ", React.createElement(Boon, {
    name: "Might"
  }), " thanks to ", React.createElement(Trait, {
    name: "HGH",
    id: "473"
  }), ", which slowly will ramp might up to 25 stacks over time. If ", React.createElement(Boon, {
    name: "Might"
  }), " is really suffering, you can also use utility skills such as ", React.createElement(Skill, {
    name: "Flame Turret",
    id: "5836"
  }), " along with ", React.createElement(Trait, {
    name: "Experimental Turrets",
    id: "1678"
  }), " to help."), "\n", React.createElement(_components.li, null, React.createElement(Boon, {
    name: "Fury"
  }), " will be provided through pressing ", React.createElement(Skill, {
    id: "63141",
    id: "63141"
  }), " off cooldown. As long as you have at least 62.5% ", React.createElement(Attribute, {
    name: "Boon Duration"
  }), " you will be able to maintain 100% uptime."), "\n", React.createElement(_components.li, null, React.createElement(Boon, {
    name: "Swiftness"
  }), " is provided mainly through ", React.createElement(Skill, {
    name: "Glob Shot",
    id: "5935"
  }), " and ", React.createElement(Skill, {
    name: "Infusion Bomb",
    id: "50444"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(Boon, {
    name: "Regeneration"
  }), " can be maintained permanantly by using ", React.createElement(Skill, {
    name: "Energizing Slam",
    id: "63169"
  }), " off cooldown. When using ", React.createElement(Skill, {
    name: "Med Kit",
    id: "5802"
  }), ", you also share it when using ", React.createElement(Skill, {
    name: "Bandage Blast",
    id: "29547"
  }), " and ", React.createElement(Skill, {
    name: "Infusion Bomb",
    id: "50444"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(Boon, {
    name: "Protection"
  }), " can be maintained permanantly by using ", React.createElement(Skill, {
    id: "63293",
    id: "63293"
  }), " off cooldown. Additionally using you Shield skills will also share some through ", React.createElement(Trait, {
    name: "Over SHield",
    id: "394"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(Boon, {
    name: "Stability"
  }), " is lacking on ", React.createElement(Specialization, {
    name: "Mechanist",
    text: "Heal Mechanist"
  }), ", with ", React.createElement(Skill, {
    id: "63293",
    id: "63293"
  }), " providing 1 stack on a 24 second cooldown (with ", React.createElement(Boon, {
    name: "Alacrity"
  }), ")."), "\n", React.createElement(_components.li, null, React.createElement(Boon, {
    name: "Aegis"
  }), " is lacking on ", React.createElement(Specialization, {
    name: "Mechanist",
    text: "Heal Mechanist"
  }), ", with ", React.createElement(Skill, {
    id: "63293",
    id: "63293"
  }), " providing 1 stack on a 24 second cooldown (with ", React.createElement(Boon, {
    name: "Alacrity"
  }), ")."), "\n", React.createElement(_components.li, null, React.createElement(Boon, {
    name: "Vigor"
  }), " can be maintained permanantly by using ", React.createElement(Skill, {
    name: "Energizing Slam",
    id: "63169"
  }), " off cooldown. When using ", React.createElement(Skill, {
    name: "Med Kit",
    id: "5802"
  }), ", you also share it when using ", React.createElement(Skill, {
    name: "Infusion Bomb",
    id: "50444"
  }), "."), "\n", React.createElement(_components.li, null, React.createElement(Effect, {
    name: "Barrier"
  }), " helps to provide ", React.createElement(Boon, {
    name: "Alacrity"
  }), " through the trait ", React.createElement(Trait, {
    name: "Mech Frame: Channeling Conduits",
    id: "2276"
  }), ", while providing excellent damage mitigation. You have 3 main methods of generating ", React.createElement(Effect, {
    name: "Barrier"
  }), "; ", React.createElement(Trait, {
    name: "Mech Core: Barrier Engine",
    id: "2281"
  }), " passivley generates it over time, Your utility skills ", React.createElement(Skill, {
    id: "63141",
    id: "63141"
  }), " and ", React.createElement(Skill, {
    name: "Barrier Signet",
    id: "63262"
  }), " and finally by using ", React.createElement(Skill, {
    name: "Barrier Blast"
  }), " Your third auto attack skill on Mace."), "\n")), React.createElement(GridItem, {
    sm: "6"
  }, React.createElement(Card, {
    title: "Pre-Stacking Boons"
  }, React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "To provide most of your boons, you can simiply cast ", React.createElement(Skill, {
    id: "63293",
    id: "63293"
  }), ", ", React.createElement(Skill, {
    id: "63141",
    id: "63141"
  }), " and ", React.createElement(Skill, {
    name: "Energizing Slam",
    id: "63169"
  }), "."), "\n", React.createElement(_components.li, null, "If there is no fire field you can provide one with ", React.createElement(Skill, {
    name: "Napalm",
    id: "5929"
  }), " (Skill 4) in ", React.createElement(Skill, {
    name: "Flamethrower",
    id: "5927"
  }), "."), "\n", React.createElement(_components.li, null, "To blast your firefield to share ", React.createElement(Boon, {
    name: "Might"
  }), ", ", React.createElement(Specialization, {
    name: "Engineer"
  }), " has blast finishers on many of its skills. Your most acessible blasts on ", React.createElement(Specialization, {
    name: "Mechanist",
    text: "Heal Mechanist"
  }), " are:", "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Acid Bomb",
    id: "5936"
  }), " in ", React.createElement(Skill, {
    name: "Elixir Gun",
    id: "5933"
  })), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Infusion Bomb",
    id: "50444"
  }), " in ", React.createElement(Skill, {
    name: "Med Kit",
    id: "5802"
  })), "\n", React.createElement(_components.li, null, "if you used ", React.createElement(Skill, {
    name: "Flamethrower",
    id: "5927"
  }), " to provide a firefield, ", React.createElement(Skill, {
    name: "Flame Blast",
    id: "5931"
  })), "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Magnetic Inversion",
    id: "6126"
  }), ", the second activation of Shield 4."), "\n"), "\n"), "\n")))), "\n", React.createElement(Divider, {
    text: "Healing"
  }), "\n", React.createElement(_components.h3, null, "Sustained Healing"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "A large amount of your sustsined healing comes from traits. ", React.createElement(Trait, {
    name: "Soothing Detonation",
    id: "1834"
  }), ", ", React.createElement(Trait, {
    name: "Compounding Chemicals",
    id: "413"
  }), " and ", React.createElement(Trait, {
    name: "Backpack Regenerator",
    id: "470"
  }), " generate a lot of passive healing to yourself, which is then shared with ", React.createElement(Trait, {
    name: "Medical Dispersion Field",
    id: "1916"
  }), " and amplified with ", React.createElement(Trait, {
    name: "Health Insurance",
    id: "521"
  }), "."), "\n", React.createElement(_components.li, null, "When under constant pressure ", React.createElement(Skill, {
    name: "Super Elixir",
    id: "5937"
  }), " and ", React.createElement(Skill, {
    name: "Elixir Shell",
    id: "30032"
  }), " can be used. It is reccomended to use ", React.createElement(Skill, {
    name: "Super Elixir",
    id: "5937"
  }), " first due to its shorter cooldwon."), "\n", React.createElement(_components.li, null, "If your parties hp is not full you can use ", React.createElement(Skill, {
    name: "Med Blaster",
    id: "30521"
  }), " in ", React.createElement(Skill, {
    name: "Med Kit",
    id: "5802"
  }), " which is very strong. However, you should first consider other abilities to heal your party quicker since you want to maximize your time on mace to generate ", React.createElement(Effect, {
    name: "Barrier"
  }), "."), "\n", React.createElement(_components.li, null, "Your best form of sustained healing is to keep your ", React.createElement(Effect, {
    name: "Barrier"
  }), " uptime high. By using  ", React.createElement(Skill, {
    id: "63141",
    id: "63141"
  }), " and ", React.createElement(Skill, {
    name: "Barrier Signet",
    id: "63262"
  }), ", your party will not lose much health due to tanking damage."), "\n"), "\n", React.createElement(_components.h3, null, "Burst Healing"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(Skill, {
    name: "Vital Burst",
    id: "49082"
  }), " and ", React.createElement(Skill, {
    name: "Bandage Blast",
    id: "29547"
  }), " can be used for some burst healing."), "\n", React.createElement(_components.li, null, "Aditionally you have 2 water fields with ", React.createElement(Skill, {
    name: "Cleansing Field",
    id: "49045"
  }), " and ", React.createElement(Skill, {
    name: "Elixir Shell",
    id: "30032"
  }), " which can then be blasted with ", React.createElement(Skill, {
    name: "Acid Bomb",
    id: "5936"
  }), ", ", React.createElement(Skill, {
    name: "Magnetic Inversion",
    id: "6126"
  }), " and ", React.createElement(Skill, {
    name: "Infusion Bomb",
    id: "50444"
  }), " for massive healing."), "\n", React.createElement(_components.li, null, "If you don't have any burst healing abilities up, you can use ", React.createElement(Skill, {
    name: "Barrier Signet",
    id: "63262"
  }), " for a large amount of ", React.createElement(Effect, {
    name: "Barrier"
  }), " to help sustain your party while you heal them back up."), "\n", React.createElement(_components.li, null, "If you are anticipating a large amount of incoming damage using ", React.createElement(Skill, {
    name: "Super Elixir",
    id: "5937"
  }), " or ", React.createElement(Skill, {
    name: "Elixir Shell",
    id: "30032"
  }), " before for strong healing over time can be useful."), "\n"), "\n", React.createElement(_components.h3, null, "Condition Cleanse"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "Your strongest condition cleanse is ", React.createElement(Skill, {
    name: "Fumigate",
    id: "5965"
  }), " in ", React.createElement(Skill, {
    name: "Elixir Gun",
    id: "5933"
  }), ", removing up to 5 conditions on 5 targets."), "\n", React.createElement(_components.li, null, "Blasting Light Fields also causes area condition cleanse. You can place light fields with ", React.createElement(Skill, {
    name: "Super Elixir",
    id: "5937"
  }), " or ", React.createElement(Skill, {
    name: "Flash Shell",
    id: "30121"
  }), " and then blast with ", React.createElement(Skill, {
    name: "Acid Bomb",
    id: "5936"
  }), ", ", React.createElement(Skill, {
    name: "Magnetic Inversion",
    id: "6126"
  }), " or ", React.createElement(Skill, {
    name: "Infusion Bomb",
    id: "50444"
  }), "."), "\n", React.createElement(_components.li, null, "If you have a high amount of condition pressure you can use ", React.createElement(Skill, {
    name: "Cleansing Field",
    id: "49045"
  }), " or ", React.createElement(Skill, {
    name: "Super Elixir",
    id: "5937"
  }), " for a longer-lasting condition cleanse over time."), "\n"), "\n", React.createElement(Divider, {
    text: "Underwater Guide"
  }), "\n", React.createElement(Warning, null, React.createElement(_components.p, null, "Remember to equip a ", React.createElement(Item, {
    id: "24842",
    id: "24842"
  }), " to your Aquabreather, so you will get the 6th bonus underwater!")), "\n", React.createElement(_components.p, null, "When underwater, ", React.createElement(Specialization, {
    name: "Mechanist",
    text: "Heal Alacrity Mechanist"
  }), " is unplayable due to your ", React.createElement(Skill, {
    name: "Crash Down",
    text: "Jade Mech",
    id: "63050"
  }), " skills not being availible, which leaves you with a couple of options. You can either swap class to a ", React.createElement(Boon, {
    name: "Alacrity"
  }), " provider that will work underwater (", React.createElement(Specialization, {
    name: "Renegade"
  }), " or ", React.createElement(Specialization, {
    name: "Tempest"
  }), "). Alternatively, if you want to stay as an ", React.createElement(Specialization, {
    name: "Engineer"
  }), " your best option is to swap to ", React.createElement(Specialization, {
    name: "Scrapper",
    text: "Heal Quickness Scrapper"
  }), "."), "\n", React.createElement(Grid, null, React.createElement(GridItem, {
    sm: "7"
  }, React.createElement(_components.h3, null, "Traits"), React.createElement(Traits, {
    traits1Id: "43",
    traits1: "Scrapper",
    traits1SelectedIds: "1917,1954,2052",
    unembossed: true,
    traits1Id: "43",
    traits1SelectedIds: "1917,1954,2052"
  }), React.createElement(_components.p, null, "Your other trait lines remain the same as on land.")), React.createElement(GridItem, {
    sm: "5"
  }, React.createElement(_components.h3, null, "Skills"), React.createElement(Skills, {
    healId: 5802,
    utility1Id: 5933,
    utility2Id: 31248,
    utility3Id: 29739,
    eliteId: 30800,
    healId: 5802,
    utility1Id: 5933,
    utility2Id: 31248,
    utility3Id: 29739,
    eliteId: 30800
  }), React.createElement(_components.h3, null, "Weapons"), React.createElement(Weapons, {
    weapon1MainType: "Speargun",
    weapon1MainAffix: "Minstrel",
    weapon1MainSigil1: "Transference",
    weapon1MainSigil2: "Water",
    weapon1MainInfusion1Id: 49432,
    weapon1MainInfusion2Id: 49432,
    weapon1MainInfusion1Id: 49432,
    weapon1MainInfusion2Id: 49432,
    weapon1MainId: "73365",
    weapon1MainSigil1Id: "74326",
    weapon1MainSigil2Id: "24551"
  }), React.createElement(_components.p, null, "The rest of your gear will remain the same as on land."))));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
